<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">
        <i class="fa-solid fa-list-check me-2"></i>
        <ng-container *ngIf="viewMode == ViewMode.INSERT">Aufgabe anlegen</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.EDIT">Aufgabe bearbeiten</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.VIEW">Aufgabe</ng-container>
        <span class="badge bg-danger ms-2 fs-6" *ngIf="task?.archived == '1'">Archiviert</span>
        <span class="badge bg-danger ms-2 fs-6" *ngIf="task?.deleted == '1'">Gelöscht</span>
    </h1>
</div>

<form [formGroup]="form">
    <div class="row">
        <div class="col">
            <label>Status</label>
            <select class="form-control" formControlName="new_status" *ngIf="viewMode != ViewMode.VIEW">
                <option value="null" disabled selected style="display: none;">Bitte auswählen</option>
                <option value="new">Neu</option>
                <option value="in_progress">In Bearbeitung</option>
                <option value="done">Erledigt</option>
                <option value="cancelled">Abgesagt</option>
            </select>
            <p *ngIf="viewMode == ViewMode.VIEW">
                <i class="fa-solid fa-circle"
                   [class.text-danger]="form.value.status?.name == 'new'"
                   [class.text-warning]="form.value.status?.name == 'in_progress'"
                   [class.text-success]="form.value.status?.name == 'done'"
                   [class.text-secondary]="form.value.status?.name == 'cancelled'"
                ></i>
                {{ form.value.status?.name | status }} ({{ form.value.status?.user}} am {{ form.value.status?.created_at | date: 'dd.MM.yyyy HH:mm'}})
            </p>
        </div>
        <div class="col">
            <label>Aufgabentyp</label>
            <select class="form-control" formControlName="id_tasktype" *ngIf="viewMode != ViewMode.VIEW">
                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                <option *ngFor="let tasktype of tasktypes" [ngValue]="tasktype.id">
                    {{ tasktype.name }}
                </option>
            </select>
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.tasktype }}</p>
        </div>
    </div>

    <div class="row" *ngIf="viewMode != ViewMode.INSERT">
        <div class="col">
            <div class="col">
                <label>Erstellt am</label>
                <p>{{ form.value.created_at | date: 'dd.MM.yyyy, HH:mm' }}</p>
            </div>
        </div>
        <div class="col">
            <div class="col">
                <label>Erstellt von</label>
                <p>
                    <a [routerLink]="['/user', form.value.id_creator]" *ngIf="form.value.creator">{{ form.value.creator }}</a>
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <label>Kunde</label>
            <!--{{ form.value.id_customer }}-->
            <input formControlName="select_customer" class="form-control" placeholder="Suche"
                   *ngIf="viewMode != ViewMode.VIEW"
                   [typeahead]="customers"
                   [typeaheadOptionField]="'select_name'"
                   (typeaheadOnSelect)="selectCustomer($event.item)"
                   (typeaheadNoResults)="typeaheadNoResults($event)">
            <div class="alert alert-danger py-1 mb-1" *ngIf="noResult">Kein Eintrag gefunden</div>
            <!--<select class="form-control" formControlName="id_customer" *ngIf="viewMode != ViewMode.VIEW">
                         <option value="">Keiner</option>
                         <option *ngFor="let customer of customers" [ngValue]="customer.id">
                             {{ customer.name }}
                         </option>
                     </select>-->
            <p *ngIf="viewMode == ViewMode.VIEW">
                <a *ngIf="form.value.id_customer" [routerLink]="['/customer', form.value.id_customer]">{{ form.value.customer }}</a>
                <span class="text-muted" *ngIf="!form.value.id_customer">Nicht gesetzt</span>
            </p>
        </div>
        <div class="col">
            <label>Kontakt</label>
            <input formControlName="select_contact" class="form-control" placeholder="Suche"
                   *ngIf="viewMode != ViewMode.VIEW"
                   [typeahead]="contacts"
                   [typeaheadOptionField]="'name'"
                   (typeaheadOnSelect)="selectContact($event.item)"
                   (typeaheadNoResults)="typeaheadNoResultsContact($event)">
            <div class="alert alert-danger py-1 mb-1" *ngIf="noResultContact">Kein Eintrag gefunden</div>
            <!--<select class="form-control" formControlName="id_contact" *ngIf="viewMode != ViewMode.VIEW">
                <option value="">Keiner</option>
                <option value="new">Neu anlegen</option>
                <option *ngFor="let contact of contacts" [ngValue]="contact.id">
                    {{ contact.name }}
                </option>
            </select>-->

            <p *ngIf="viewMode == ViewMode.VIEW">
                <a *ngIf="form.value.id_contact" [routerLink]="['/contact', form.value.id_contact]">{{ form.value.contact }}</a>
                <span class="ms-2" *ngIf="form.value.contact_phone"><i class="fa-solid fa-mobile-screen me-1"></i><a [href]="'tel:' + form.value.contact_phone">{{ form.value.contact_phone }}</a></span>
                <span class="text-muted" *ngIf="!form.value.id_contact">Nicht gesetzt</span>
            </p>
        </div>
    </div>

    <div *ngIf="form.value.id_contact == '0' && form.value.select_contact == 'Neu'" class="mt-3 new-contact">
        <div class="row">
            <div class="col">
                <label>Name</label>
                <input type="text" class="form-control" formControlName="new_contact_name">
            </div>
            <div class="col">
                <label>PLZ</label>
                <input type="number" class="form-control" formControlName="new_contact_zip">
            </div>
        </div>

        <div class="row">
            <div class="col">
                <label>Ort</label>
                <input type="text" class="form-control" formControlName="new_contact_city">
            </div>
            <div class="col">
                <label>Straße</label>
                <input type="text" class="form-control" formControlName="new_contact_street">
            </div>
        </div>

        <div class="row">
            <div class="col">
                <label>Telefon</label>
                <input type="text" class="form-control" formControlName="new_contact_phone">
            </div>
            <div class="col">
                <label>E-Mail</label>
                <input type="text" class="form-control" formControlName="new_contact_mail">
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <label>Titel</label>
            <input type="text" class="form-control" formControlName="title" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.title }}</p>
        </div>
        <div class="col">
            <label>Nummer</label>
            <p>{{ form.value.id }}</p>
        </div>
    </div>

    <label>Beschreibung</label>
    <textarea class="form-control" formControlName="description" rows="7" *ngIf="viewMode != ViewMode.VIEW"></textarea>
    <p *ngIf="viewMode == ViewMode.VIEW" [innerHTML]="task?.descriptionConverted"></p>

    <div class="row">
        <div class="col">
            <label>Fälligkeit</label>
            <input type="date" class="form-control" formControlName="due_date" [min]="today" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.due_date | date: 'dd.MM.yyyy' }}</p>
        </div>
        <div class="col">
            <label>Erinnerung</label>
            <input type="date" class="form-control" formControlName="reminder_date" [min]="today" [max]="form.value.due_date" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">
                {{ form.value.reminder_date | date: 'dd.MM.yyyy' }}
                <span class="text-muted" *ngIf="!form.value.reminder_date">Nicht gesetzt</span>
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <label>Abteilung</label>
            <select class="form-control" formControlName="department" *ngIf="viewMode != ViewMode.VIEW">
                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                <option *ngFor="let department of departments" [ngValue]="department">
                    {{ department.name }}
                </option>
            </select>
            <p *ngIf="viewMode == ViewMode.VIEW">
                {{ form.value.department.name }}
                <span class="text-muted" *ngIf="!form.value.department">Nicht gesetzt</span>
            </p>
        </div>
        <div class="col">
            <label>Bearbeiter</label>
            <p class="form-text" *ngIf="form.value.department.users?.length == 0">Keine Bearbeiter für diese Abteilung definiert</p>
            <select class="form-control" formControlName="id_editor" *ngIf="viewMode != ViewMode.VIEW && form.value.department.users?.length > 0">
                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                <option *ngFor="let user of form.value.department.users" [ngValue]="user.id">
                    {{ user.firstname }} {{ user.lastname }}
                </option>
            </select>
            <p *ngIf="viewMode == ViewMode.VIEW">
                <a [routerLink]="['/user', form.value.id_editor]" *ngIf="form.value.editor">{{ form.value.editor }}</a>
                <span class="text-muted" *ngIf="!form.value.editor && form.value.department.users?.length > 0">Nicht gesetzt</span>
            </p>
        </div>
    </div>

    <ng-container *ngIf="viewMode != ViewMode.INSERT">
        <label>Anhänge</label>
        <p>
            <span class="text-muted" *ngIf="files.length == 0">Keine Anhänge vorhanden</span>
        </p>

        <div class="table-responsive">
            <table *ngIf="files.length > 0" class="table table-sm table-hover table-files">
                <thead>
                <tr>
                    <th *ngIf="viewMode != ViewMode.VIEW"></th>
                    <th>Name</th>
                    <th>Typ</th>
                    <th>Vorschau</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let file of files">
                    <td *ngIf="viewMode != ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="deleteFile(file)"><i class="fa-solid fa-trash"></i></button>
                    </td>
                    <td>{{ file.name }}</td>
                    <td>{{ file.type | filetype }}</td>
                    <td>
                        <img *ngIf="file.thumbnail" [src]="'data:' + file.type + ';base64,' + file.thumbnail">
                        <span *ngIf="!file.thumbnail">Nicht verfügbar</span>
                    </td>
                    <td>
                        <button type="button" class="btn btn-primary btn-sm" (click)="getFileData(file)">
                            <span *ngIf="file.type.startsWith('audio/')">Abspielen</span>
                            <span *ngIf="!file.type.startsWith('audio/')">Herunterladen</span>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </ng-container>

    <ng-container *ngIf="viewMode != ViewMode.VIEW">
        <label>Neue Anhänge</label>
        <p>
            <span class="text-muted" *ngIf="files.length == 0">Keine neuen Anhänge</span>
        </p>

        <div>
            <button type="button" class="btn btn-primary btn-sm" (click)="triggerFileInput()"><i class="fa-solid fa-image"></i> Fotos oder Dateien auswählen</button>
            <input type="file" #inputFile multiple class="d-none" (change)="handleInputChange($event)">

            <div class="mt-2">
                <button type="button" class="btn btn-sm btn-primary" *ngIf="!recording" (click)="startAudioRecording()">
                    <i class="fa-solid fa-microphone"></i> Aufnehmen
                </button>

                <div *ngIf="recording">
                    <div class="recording-elapsed-time">
                        <p class="elapsed-time"><i class="fa-solid fa-circle text-danger"></i> Aufnahme läuft: {{elapsedTime}}</p>
                    </div>

                    <button type="button" class="btn btn-sm btn-primary me-2" (click)="cancelAudioRecording()">
                        <i class="fa-solid fa-circle-xmark"></i> Abbrechen
                    </button>

                    <button type="button" class="btn btn-sm btn-primary" (click)="stopAudioRecording()">
                        <i class="fa-solid fa-circle-stop"></i> Stoppen
                    </button>
                </div>
            </div>
            <div *ngIf="notSupported">
                <div class="browser-not-supporting-audio-recording-box">
                    <p>To record audio, use browsers like Chrome and Firefox that support audio recording.</p>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <table *ngIf="newFiles.length > 0" class="table table-sm table-hover table-files">
                <thead>
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Typ</th>
                    <th>Vorschau</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let file of newFiles">
                    <td>
                        <button type="button" class="btn btn-danger btn-sm" (click)="deleteNewFile(file)"><i class="fa-solid fa-trash"></i></button>
                    </td>
                    <td>{{ file.name }}</td>
                    <td>{{ file.type | filetype }}</td>
                    <td>
                        <img *ngIf="file.type.startsWith('image')" [src]="file.data">
                        <span *ngIf="!file.type.startsWith('image')">Nicht verfügbar</span>
                    </td>
                    <td>
                        <button type="button" class="btn btn-primary btn-sm" (click)="playAudioAgain(file)" [disabled]="playing && file.type == 'audio/webm'">
                            <span *ngIf="file.type.startsWith('audio/')">Abspielen</span>
                            <span *ngIf="!file.type.startsWith('audio/')">Herunterladen</span>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</form>

<audio [hidden]="!playing" controls #audioElement (ended)="playing = false"></audio>

<div style="border-top: 1px solid #dee2e6" class="mt-3 py-3">
    <ng-container *ngIf="viewMode == ViewMode.VIEW && task">
        <ng-container *ngIf="task.deleted == '0' && task.archived == '0'">
            <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)" *ngIf="accessService.isEditor(task) || task.id_editor == null || accessService.hasRight('EDIT_TASKS_ALWAYS')">Bearbeiten</button>
            <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
            <button type="button" class="btn btn-danger float-end" *ngIf="accessService.isEditor(task) || accessService.hasRight('ADMIN')" (click)="delete()">Löschen</button>
            <button type="button" class="btn btn-dark me-2 float-end" *ngIf="accessService.isEditor(task) || accessService.hasRight('ADMIN')" (click)="archive()">Archivieren</button>
            <button type="button" class="btn btn-info me-2 float-end" *ngIf="accessService.isEditor(task) || accessService.hasRight('ADMIN')" (click)="duplicate()">Duplizieren</button>
        </ng-container>
        <ng-container *ngIf="task.deleted == '1'">
            <button type="button" class="btn btn-secondary" *ngIf="accessService.hasRight('ADMIN')" (click)="undelete()">Wiederherstellen</button>
            <button type="button" class="btn btn-danger float-end" *ngIf="accessService.hasRight('ADMIN')" (click)="deleteReal()">Endgültig löschen</button>
        </ng-container>
        <ng-container *ngIf="task.archived == '1'">
            <button type="button" class="btn btn-secondary me-2" *ngIf="accessService.isEditor(task) || accessService.hasRight('ADMIN')" (click)="unarchive()">Wiederherstellen</button>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="viewMode == ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid || saving" (click)="update()">{{ saving ? 'Wird gespeichert...' : 'Aktualisieren' }}</button>
        <button type="button" class="btn btn-secondary ms-2" [disabled]="saving" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode == ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid || saving" (click)="save()">{{ saving ? 'Wird gespeichert...' : 'Speichern' }}</button>
        <button type="button" class="btn btn-secondary ms-2" [disabled]="saving" (click)="cancel()">Abbrechen</button>
    </ng-container>
</div>
